import { useDeleteMutation } from "../../hooks/general/useDeleteMutation";
import { paths } from "../../navigation/paths";
import { appStrings } from "../../resources/strings/app";
import { caseStrings as strings } from "../../resources/strings/cases";
import { api } from "../../services/cases.service";
import type { CaseData } from "../../types/documents";
import { BreadcrumbHeader } from "../general/BreadcrumbHeader";
import { DeleteEntityButton } from "../general/DeleteEntityButton";
import { Loader } from "../general/Loader";
import { SaveEntityButtons } from "../general/SaveEntityButtons";
import type { CustomProps } from "../general/types/Modify";
import { crumbs } from "./crumbs";

interface Props extends CustomProps<CaseData> {}
type Component = (props: Props) => JSX.Element;

export const CaseBreadcrumbHeader: Component = (props) => {
  const { data, mode, permissions } = props;
  const { clientId, caseId } = data;

  const { deleteInProgress, deleteFn } = useDeleteMutation(
    api.delete,
    clientId,
    caseId,
    paths.clients.view(clientId)
  );

  return (
    <BreadcrumbHeader
      crumbs={crumbs(mode, clientId)}
      children={
        <Loader active={deleteInProgress} inline>
          <>
            {mode !== "create" && (
              <DeleteEntityButton
                permissions={permissions}
                config={{
                  label: strings.labels.delete,
                  heading: strings.header.deleteCase,
                  message: strings.labels.confirmDelete,
                  entity: appStrings.entities.cases,
                }}
                handleDelete={deleteFn}
              />
            )}
            <SaveEntityButtons
              {...props}
              config={{
                entity: appStrings.entities.cases,
                editLabel: strings.labels.edit,
                saveLabel: strings.labels.save,
                resetLabel: strings.labels.reset,
              }}
            />
          </>
        </Loader>
      }
    />
  );
};
